import { EventRepository } from '~repositories/EventRepository';
import { events } from '@estee/elc-service-bus';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';
import { Event } from '~entities/Event';

export class RemoveItemUseCase {
    private eventRepository: EventRepository;
    private skuId: string;

    constructor(skuId: string) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.skuId = skuId;
    }

    public execute = () => {
        const removeItemPayload = {
            event_name: 'remove',
            event_category: 'ecommerce',
            event_action: 'remove from bag',
            enh_action: 'remove'
        };

        const cartProductPayload = {
            skuId: this.skuId
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.REMOVE_ITEM,
            type: 'link',
            payload: removeItemPayload,
            data: {
                cartProduct: cartProductPayload
            }
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
